module.exports = __webpack_public_path__ + "img/custom-template.8da1d510.png";